import { Component, ElementRef, Inject, Injector, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom } from 'rxjs';
import { CloudProvider } from 'src/app/core/models/cloudProvider';
import { DeploymentParameter, DeploymentJsonBody } from 'src/app/core/models/deployment';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { ConfigEntityService } from '../../../../core/services/config-entity.service';
import { NavigationService } from '../../../../core/services/navigation.service';
import { CredentialListComponent } from '../../../credential/credential-list/credential-list.component';
import { NodeConfigService } from '../../../../core/services/node-config.service';
import { NodeService } from '../../../../core/services/node.service';
import { FormRefreshData, FunctionDispatcherService } from 'src/app/core/services/function-dispatcher.service';
import { ListNodeConfiguratorComponent } from 'src/app/modules/pages/configurator/node-configurator/list-node-configurator/list-node-configurator.component';

@Component({
  selector: 'app-add-deployment',
  templateUrl: './add-deployment.component.html',
  styleUrls: ['./add-deployment.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddDeploymentComponent implements OnInit {
  currentUserRole =
    this.authenticationService.getRole() == ''
      ? null
      : this.authenticationService.getRole();
  showSkipDeployment: boolean = true;
  fieldTextType: boolean = true;
  cloudName: string = this.data.provider.providerName;
  cloudValue: number = +this.data.provider.providerValue;
  image: string = this.data.provider.providerIconFileName;
  dataButtonId: string = '';

  constructor(
    public dialogRef: MatDialogRef<AddDeploymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { provider: CloudProvider },
    public depService: DeploymentService,
    private spinner: NgxSpinnerService,
    private snackbar: MatSnackBar,
    private eleRef: ElementRef,
    private authenticationService: AuthenticationService,
    private dispatcher: FunctionDispatcherService,
    private renderer: Renderer2,
    private injector: Injector,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private configEntityService: ConfigEntityService,
    private navService: NavigationService,
    public nodeService: NodeService,
    public nodeConfigService: NodeConfigService,
    private formComm: FunctionDispatcherService
  ) {}

  @ViewChild('customHtmlBody') customHtmlBody: ElementRef;
  @ViewChild('skipDeployment') skipDeployment: ElementRef;
  htmlBody: string = '';

  async ngOnInit() {
    this.spinner.show('addDeployment');
    this.formComm.refreshForm$.subscribe((data: FormRefreshData) => {
      if (data.refreshForm) {
        this.refreshForm(data?.name, data?.action);
      }
    });
    if (
      //this.cloudName?.toLowerCase().includes('vdi') ||
      this.cloudName?.toLowerCase().includes('kvm') 
    ) {
      this.showSkipDeployment = false;
    }
    if (!this.currentUserRole) {
      this.snackbar.open('You do not permission to add new deployment.', 'Ok');
    }
    this.htmlBody = await lastValueFrom(
      this.depService.getCloudProviderDetails(this.cloudValue, this.cloudName)
    );
    this.spinner.hide('addDeployment');
    setTimeout(() => { this.handlePassIcon() }, 1000);
    const credentialListComponent = new CredentialListComponent(
      this.snackbar,
      this.dialog,
      this.configEntityService,
      this.depService,
      this.navService,
      this.authenticationService
    );

    const listNodeConfiguratorComponent = new ListNodeConfiguratorComponent(
      this.dialog,
      this.depService,
      this.nodeService,
      this.nodeConfigService,
      this.spinner,
      this.snackBar,
      this.navService,
      this.configEntityService,
      this.authenticationService
    );

    this.dispatcher.registerComponent('CredentialListComponent', credentialListComponent);
    this.dispatcher.registerComponent('ListNodeConfiguratorComponent', listNodeConfiguratorComponent);
  }

  handlePassIcon() {
    if(this.htmlBody == '') return;
    const pwdInput = document.getElementById('pwd') as HTMLInputElement;
    const allMasks = this.eleRef.nativeElement.querySelectorAll('.passEyeIcon');
  
    if (pwdInput) {
      pwdInput.addEventListener('click', this.togglePasswordIcon, false);
    }
  
    if (allMasks) {
      allMasks.forEach((element) => {
        element.addEventListener('click', (event) => {
          const clickedElement = event.currentTarget.parentElement.firstChild as HTMLInputElement;
          const type = clickedElement.getAttribute('type');
          const isTextType = type === 'text';
  
          if (clickedElement.value !== '') {
            const newType = isTextType ? 'password' : 'text';
            clickedElement.setAttribute('type', newType);
  
            const addClass = isTextType ? 'bi-eye-fill' : 'bi-eye-slash-fill';
            const removeClass = isTextType ? 'bi-eye-slash-fill' : 'bi-eye-fill';
  
            event.currentTarget.classList.remove(removeClass);
            event.currentTarget.classList.add(addClass);
          } else if (event.currentTarget.classList.contains('bi-eye-slash-fill')) {
            event.currentTarget.classList.remove('bi-eye-slash-fill');
            event.currentTarget.classList.add('bi-eye-fill');
          }
        });
      });
    }

    // Select all dynamic buttons
    const buttons = this.eleRef.nativeElement.querySelectorAll('.dynamic-add-btn');

    // Attach listeners
    buttons.forEach((btn: any) => {
      const callString = btn.getAttribute('data-call');
      const dataButtonId = btn.getAttribute('data-button-id');
      this.renderer.listen(btn, 'click', () => {
        this.onAddButtonClick(callString, dataButtonId);
      });
    });
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.handlePassIcon();
  }

  onCancel() {
    this.snackbar.dismiss();
    this.dialogRef.close();
  }

  onSubmit() {
    if (!this.currentUserRole) return;
    let elements = this.customHtmlBody.nativeElement.getElementsByTagName('tr');
    let skipCloudDep;
    if (this.skipDeployment) {
      skipCloudDep = (<any>this.skipDeployment).checked;
    }

    let depParams: DeploymentParameter[] = [];
    for (let i = 0; i < elements.length; i++) {
      let ele = elements[i].lastChild.firstChild;
      var depkey = ele.id;
      var depval = ele.value;
      let regexp = new RegExp(ele.getAttribute('pattern'));

      if (ele.hasAttribute('required')) {
        if (!depval || depval === '') {
          this.snackbar.open(
            ele.parentElement.previousElementSibling.innerText.trim() +
            ' Required!',
            'Ok'
          );
          return false;
        }
      }

      if (regexp && regexp.source != 'null' && depval !== '') {
        if (!regexp.test(depval)) {
          this.snackbar.open(
            ele.parentElement.previousElementSibling.innerText.trim() +
            ' is Invalid!',
            'Ok'
          );
          return false;
        }
      }

        depParams.push({ depKey: depkey, depValue: depval });
    }
    var depJsonBody = new DeploymentJsonBody(depParams);
    this.spinner.show('addDeployment');
    if (this.showSkipDeployment) {
      this.depService
        .createDeployment(
          this.cloudValue,
          this.cloudName,
          depJsonBody,
          skipCloudDep
        )
        .subscribe({
          next: (data) => {
            this.spinner.show('addDeployment');
            this.dialogRef.close(depParams);
          },
          error: (err) => {
            this.snackbar.open(err?.error?.actionMessage || "Something went wrong.", 'Ok', {
                duration: 10000,
              });
            this.spinner.hide('addDeployment');
          },
        });
    } else {
      this.depService
        .createDeployment(this.cloudValue, this.cloudName, depJsonBody, true)
        .subscribe({
          next: (data) => {
            this.spinner.show('addDeployment');
            this.dialogRef.close(depParams);
          },
          error: (err) => {
            this.snackbar.open(err?.error?.actionMessage || "Something went wrong.", 'Ok', {
                duration: 10000,
              });
            this.spinner.hide('addDeployment');
            // this.dialogRef.close();
          },
        });
    }
  }

  togglePasswordIcon() {
    this.fieldTextType = !this.fieldTextType;
    if (this.fieldTextType) {
      (<HTMLInputElement>document.getElementById('adminPassword')).type =
        'text';
    } else {
      (<HTMLInputElement>document.getElementById('adminPassword')).type =
        'password';
    }
  }

  onAddButtonClick(callString: string, dataButtonId: string) {
    this.dataButtonId = dataButtonId.trim();
    this.dispatcher.dispatch(callString);
  }

  refreshForm(name: string, action: string) {
    if (name && action) {
      const selectElement = this.customHtmlBody.nativeElement.querySelector(`select[name="${this.dataButtonId}"]`);
      if (selectElement) {
        // Create new option
        const newOption = document.createElement('option');
        newOption.value = name;
        newOption.text = name || name;

        // Add the option to select
        selectElement.appendChild(newOption);

        // Make it selected
        selectElement.value = name;

        const changeEvent = new Event('change', { bubbles: true });
        selectElement.dispatchEvent(changeEvent);
      }
      this.spinner.show('addDeployment');

      this.depService.getCloudProviderDetails(this.cloudValue, this.cloudName)
        .subscribe({
          next: (data) => {
            this.htmlBody = data;
            this.spinner.hide('addDeployment');

            // Re-initialize password icons and dynamic buttons after refresh
            setTimeout(() => {
              this.handlePassIcon();
            }, 100);
          },
          error: (err) => {
            this.spinner.hide('addDeployment');
            console.error('Error refreshing form:', err);
          }
        });
    }
  }
}
